import { ChatModuleType } from 'app/copied/models/ChatModules';
import useModule from 'app/hooks/useModule';
import { ModuleItemActionType } from 'app/services/helpCenter';

export default function useVirtualAssistantAvatar() {
  const vaModule = useModule(ChatModuleType.VirtualAssistant);
  const containerModule = useModule(ChatModuleType.Container);

  if (vaModule?.header_icon) {
    return vaModule?.header_icon;
  }

  const vaButton = containerModule?.items?.find(
    (item) => item?.action_obj?.action_type === ModuleItemActionType.OPEN_VIRTUAL_ASSISTANT
  );

  return vaButton?.icon;
}
